<template>
  <div v-if="page">
  

    <ULandingSection v-for="(section, index) in page.sections" :key="index" :title="section.title"
                     :description="section.description" :align="section.align" :features="section.features">
      <NuxtImg :src="section.image" :alt="section.title"
               class="w-full rounded-md shadow-xl ring-1 ring-gray-300 dark:ring-gray-700" />
    </ULandingSection>
  </div>
</template>

<script setup lang="ts">
const { data: page } = await useAsyncData('trainingen', () => queryContent('/').findOne())
if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}

useSeoMeta({
  titleTemplate: '',
  title: page.value.title,
  ogTitle: page.value.title,
  description: page.value.description,
  ogDescription: page.value.description
})
</script>
